import React,{useEffect, useState} from 'react';
import {getUserToken} from 'libs/helpers';

import Artiste from 'components/blocks/Artiste';
// import ArtisteCatalog from 'pages/ArtisteCatalog';
import LandingPage from 'pages/LandingPage';


const FollowingPage = props => {
    let artiste = {name:"Falz", occupation:"Musician", imageUrl:"/images/png/no_artist.png", numberOfSongs:"4,000"};
    const [artist, setArtist] = useState({});

    useEffect( () => {
        fetch(`https://musicandrights.herokuapp.com/api/v1/user/get_assigned`, {
            method: 'GET',
            headers: {'Authorization': `Bearer ${getUserToken()}`,
                            'Content-Type': 'application/json'}
        })
        .then( res => res.json())
        .then( res => {
            // console.log(res)
            setArtist(res.data);
        })
        .catch( err => {
            // console.log('[SUBSTATION]',err)
            });
    },[])
  return (

      !artist.hasOwnProperty('assigned_artist') ?  <LandingPage /> : 
     (
         <div className="row mt-md-5 extra">
            <div className="w-100" style={{ paddingLeft: 12 }}>
                <ul className="catalog-menu">
                <li className="catalog-menu-items text--large active">Following</li>
                </ul>
            </div>
            <div className="row mx-0 mt-2 mt-md-2">
                <div className="col-6 col-md-4">
                    { artist.hasOwnProperty('assigned_artist') ?
                        (
                            <Artiste
                                name={artist.assigned_artist}
                                occupation={artiste.occupation}
                                imageUrl={artiste.imageUrl}
                                hideTrash={true}
                                />
                        ) : null
                    }
                    
                </div>
                {/* <div className="col-6 col-md-3">
                    <Artiste
                        name={artist.name}
                        occupation={artiste.occupation}
                        imageUrl={artiste.imageUrl}
                        />
                </div> */}
            </div>
            {/* {
                !artist.hasOwnProperty('name') ? 
                (
                    <div className="col-md-5 mx-auto mt-5">
                        <p className="text-center">You are yet to be assigned an artist</p>
                    </div>
                ) : null
            } */}
            </div>
     )
  );
};

export default FollowingPage;
